import React from 'react';
import ServicesHero from './sections/ServicesHero';
import ServicesGrid from './sections/ServicesGrid';
import ServicesCTA from './sections/ServicesCTA';

const ServicesPage = () => {
  return (
    <main className="min-h-screen bg-black">
      <ServicesHero />
      <ServicesGrid />
      <ServicesCTA />
    </main>
  );
};

export default ServicesPage;